import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { calculateFinalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils.js';
import {
  StoreSpecialMsgContainer,
  OfferPrice,
  MessageWrapper,
} from './styles/StoreSpecialMsg.style';
import {
  getStoreSpecialDiscountValue,
  getPromotionsData,
} from '../../../../common/organisms/Promotions/container/Promotions.selectors';
import { getShowBopisTileBasedOnStoreSpecials } from '../../../../../reduxStore/selectors/session.selectors';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

const StoreSpecialMsg = ({
  offerPrice,
  storeSpecialDiscount,
  isStoreSpecialsPriceOn,
  isStoreSpecialEligible,
  TCPPromotionPrice,
  TCPPromotionID,
  activePromotions,
  fromStoreSpecialsCarousel,
}) => {
  const tmpPromotionalPrice =
    TCPPromotionID && activePromotions[TCPPromotionID] ? TCPPromotionPrice : '';

  // Calculate the discounted price
  const discountedPrice = calculateFinalPrice(
    offerPrice,
    storeSpecialDiscount,
    tmpPromotionalPrice
  );
  const msg = getDynamicLabelValues('dynamic.browse_d.lbl_spl_store_msg1') || '';

  return (
    <>
      {isStoreSpecialsPriceOn && isStoreSpecialEligible && (
        <StoreSpecialMsgContainer fromStoreSpecialsCarousel={fromStoreSpecialsCarousel}>
          <OfferPrice fromStoreSpecialsCarousel={fromStoreSpecialsCarousel}>
            ${discountedPrice}
          </OfferPrice>
          <MessageWrapper fromStoreSpecialsCarousel={fromStoreSpecialsCarousel}>
            {msg || 'with store pickup only'}
          </MessageWrapper>
        </StoreSpecialMsgContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    storeSpecialDiscount: getStoreSpecialDiscountValue(state),
    isStoreSpecialsPriceOn: getShowBopisTileBasedOnStoreSpecials(state),
    activePromotions: getPromotionsData(state),
  };
};

StoreSpecialMsg.propTypes = {
  offerPrice: PropTypes.string.isRequired,
  isStoreSpecialEligible: PropTypes.bool,
};

StoreSpecialMsg.defaultProps = {
  isStoreSpecialEligible: false,
};

const withConnect = connect(mapStateToProps);
export default compose(withConnect)(StoreSpecialMsg);
